var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.tax,
            callback: function($$v) {
              _vm.tax = $$v
            },
            expression: "tax"
          }
        },
        [
          _vm.hasInvoice
            ? _c("div", [
                _c("h3", { staticClass: "mt-0" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Appliquer la TVA sur les factures d'acompte"
                        )
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("el-checkbox", { attrs: { label: "taxOnDeposit" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$l10n.__(
                            "Appliquer la TVA sur les factures d'acompte"
                          )
                        )
                      )
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("h3", { class: { "mt-0": !_vm.hasInvoice } }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$l10n.__("Assiette de TVA")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "L'assiette de TVA est la base sur laquelle le montant de la TVA sera calculé"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "vatBase" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Afficher l'assiette de TVA")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alert alert-warning" }, [
            _c("p", [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "L'assiette de TVA n‘est pas disponible sur les documents utilisant la double taxe"
                    )
                  ) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c("h3", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$l10n.__("Double taxe")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Certains pays ou territoires utilisent deux taxes différentes."
                  )
                ) +
                "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Activez cette préférence si vous souhaitez que tous vos documents comportent deux colonnes de taxe."
                  )
                ) +
                "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Cette préférence peut aussi être activée document par document."
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "doubleVat" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__("Utiliser la double taxe dans les documents")
                  )
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.save") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.save($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }